export default __webpack_public_path__ + "static/media/bkg--interiors-1.51d20673.jpg";